export const FIXES_TYPES = [
  { itemValue: 'NAVAID', itemLabel: 'NAVAID', length: 3 },
  { itemValue: 'FIX', itemLabel: 'FIX', length: 5 },
];

export const POINT_USES = [
  { itemValue: 'FIX', itemLabel: 'FIX' },
  { itemValue: 'VOR/DME', itemLabel: 'VOR/DME' },
  { itemValue: 'DME', itemLabel: 'DME' },
  { itemValue: 'NDB', itemLabel: 'NDB' },
  { itemValue: 'NDB/DME', itemLabel: 'NDB/DME' },
  { itemValue: 'TACAN', itemLabel: 'TACAN' },
  { itemValue: 'UHF/NDB', itemLabel: 'UHF/NDB' },
  { itemValue: 'VOR', itemLabel: 'VOR' },
  { itemValue: 'VORTAC', itemLabel: 'VORTAC' },
  { itemValue: 'DVOR', itemLabel: 'DVOR' },
  { itemValue: 'DVOR/DME', itemLabel: 'DVOR/DME' },
];
